// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YaXIz","content":"styles_content__2k3W_","row":"styles_row__7yT5P","footer":"styles_footer__UgE19","phraseLength":"styles_phraseLength__2fNi1"};